import { OtherHouses } from '@mui/icons-material';

export default {
  ACCOUNTING_CODE: 'Accounting Code',
  ACCEPTED_FORMATS: '(Accepted formats: JPEG, PNG, JPG)',
  ACTIONS: 'Actions',
  ACTIVE: 'Active',
  ADD: 'Add',
  ADD_SUPPLIER: 'Add Supplier',
  ADD_TAX: 'Add Tax',
  ADD_NEW_TAX: 'Add New Tax',

  ADDING_NEW_CATEGORY_DETAILS: 'Adding new Category Details...',
  ADDING_NEW_SUB_CATEGORY_DETAILS: 'Adding new Subcategory Details...',
  ADDING_NEW_SUPPLIER_DETAILS: 'Adding new Supplier Details...',

  ADDRESS: 'Address',
  ADMIN_PROFILE: 'Admin Profile',
  APPLY: 'Apply',
  AUTHENTICATING: 'Authenticating...',

  BACKORDER: 'Backorder',
  BAKEASY_ADMIN_PORTAL: 'Order-EZ Admin Portal',
  BILL_TO: 'Bill To',
  BILL_TO_COUNTRY: 'Bill to Country',
  BILL_TO_NAME: 'Bill To Name',
  BILLING: 'Billing',
  BILLING_DETAILS: 'Billing Details',

  CANCEL: 'Cancel',
  CATEGORY: 'Category',
  CHAIN_STORE_NAME: 'Chain Store Name',
  CHAIN_STORE_PARENT: 'Chain Store/Parent Company',
  CHANGE_PASSWORD: 'Change Password',
  CITY: 'City',

  COMPANY_ADDRESS: 'Company Address',
  COMPANY_NAME: 'Company Name',
  COMPOSE: 'Compose',

  CONFIRM_PASSWORD: 'Confirm Password',
  CONTACT: 'Contact',
  CONTACT_ACCOUNTING: 'Contact Accounting',
  CONTACT_STORE: 'Contact Customer',
  CONTACT_SUPPLIER: 'Contact Supplier',
  CONTACT_SUPPORT: 'Please contact System Technical Support',
  CONTACT1: 'Contact 1',
  CONTACT2: 'Contact 2',

  CONTENT: 'Content',
  CREATE: 'Create',
  CREATED_DATE: 'Created Date',
  COUNTRY: 'Country',
  CURRENT_PASSWORD: 'Current Password',

  DATE: 'Date',
  DATE_CREATED: 'Date Created',
  DATE_MM_DD_YYYY: 'Date',
  DATE_REGISTERED: 'Date Registered',
  DEACTIVATE: 'DEACTIVATE',
  DEACTIVATE_SUPPLIER: 'Deactivate Supplier',
  DEACTIVATE_SUPPLIER_MESSAGE:
    'Are you sure you want to Deactivate this supplier?',
  DEACTIVATING_SUPPLIER: 'Deactivating Supplier...',
  DEACTIVE: 'Deactive',
  DELETE: 'Delete',
  DELETE_MESSAGE: 'Delete Messages',
  DELETE_MESSAGE_CONFIRMATION: 'Are you sure you want to delete this message?',
  DELETING_MESSAGE: 'Deleting Message...',
  DESCRIPTION: 'Description',
  DIFFERENT_LEGAL_NAME: 'Different Legal Name',
  DISCOUNT: 'Discount',
  DISCOUNT_PER: 'Discount % of Retail Price',

  DOWNLOAD_FAILURE: 'Download Failure',
  DOWNLOAD_SUCCESS: 'Download Success',
  DOWNLOADING_STORE: 'Downloading Customer...',
  DOWNLOADING_STORE_DETAILS: 'Downloading Customer Details...',
  DOWNLOADING_SUBCATEGORIES: 'Downloading Subcategories...',
  DOWNLOADING_SUPPLIER_LIST: 'Downloading Supplier list..',
  DUPLICATE: 'Duplicate',

  EDIT: 'Edit',
  EDIT_SUPPLIER: 'Edit Supplier',
  EMAIL: 'Email',
  EMAIL_ID: 'Email ID',

  ENTER: 'Enter ',
  ENTER_ACCOUNTING_CODE: 'Enter Accounting code',
  ENTER_CHAIN_STORE_NAME: 'Enter Chain Store Name',
  ENTER_EMAIL_ID: 'Enter Email ID',
  ENTER_FIRST_NAME: 'Enter First Name',
  ENTER_LAST_NAME: 'Enter Last Name',
  ENTER_LEGAL_NAME: 'Enter Legal Name',
  ENTER_MESSAGE: 'Enter Message',
  ENTER_NAME: 'Enter Name',
  ENTER_MASTER_PASSWORD: 'Enter Master Password',
  ENTER_MOBILE_NUMBER: 'Enter Mobile Number',
  ENTER_PARENT_POSTAL_CODE: 'Enter parent Zip/Postal Code',
  ENTER_PARENT_ADDRESS: 'Enter Parent Address',
  ENTER_PARENT_CITY: 'Enter Parent City',
  ENTER_PARENT_COUNTRY: 'Enter Parent Country',
  ENTER_PARENT_STATE: 'Enter Parent State/Province',
  ENTER_PASSWORD: 'Enter Password',
  ENTER_PHONE_NUMBER: 'Enter phone number',

  ENTER_SUPPLIER_CITY: 'Enter Supplier City',
  ENTER_SUPPLIER_COUNTRY: 'Enter Supplier Country',
  ENTER_SUPPLIER_NAME: 'Enter Supplier Name',
  ENTER_SUPPLIER_STATE: 'Enter Supplier State/Province',
  ENTER_SUPPLIER_POSTAL_CODE: 'Enter Supplier Zip/Postal Code',

  ENTER_USER_NAME: 'Enter User Name',
  ENTER_WORK: 'Enter Work',
  ENTER_YOUR_EMAIL: 'Enter your Email',
  ENTER_YOUR_PASSWORD: 'Enter your Password',
  ENTER_YOUR_USERNAME: 'Enter your Username',
  EXPORT: 'Export',

  FETCHING_CATEGORIES: 'Fetching Categories...',
  FETCHING_CATEGORIES_DETAILS: 'Fetching Categories Details...',
  FETCHING_CITIES: 'Fetching Cities...',
  FETCHING_COUNTRIES: 'Fetching Countries',
  FETCHING_MESSAGE_STATUS: 'Fetching Message Status...',
  FETCHING_MESSAGES: 'Fetching Messages...',
  FETCHING_NAMES: 'Fetching Names...',
  FETCHING_PRODUCTS: 'Fetching Products...',
  FETCHING_PRODUCTS_DETAILS: 'Fetching Products Details...',
  FETCHING_REPLIES: 'Fetching Replies...',
  FETCHING_SUBCATEGORIES: 'Fetching Subcategories...',
  FETCHING_STATES: 'Fetching States...',
  FETCHING_STORES: 'Fetching Customers...',
  FETCHING_STORES_DETAILS: 'Fetching Customer Details...',
  FETCHING_SUPPLIERS: 'Fetching Suppliers...',
  FETCHING_SUPPLIER_DETAILS: 'Fetching Supplier Details...',
  FETCHING_TAX: 'Fetching Tax',

  FILE_SIZE_MSG: 'File size exceeds 2 MB limit. Please choose a smaller file',
  FILTER: 'Filter',
  FIRST_NAME: 'First Name',
  FORGOT_PASSOWRD: 'Forgot Password?',
  FROM: 'From',

  GETTING_USER_PROFILE: 'Getting User Profile...',

  IMAGE: 'Image',
  INACTIVE: 'Inactive',
  INGREDIENT_IMAGE: 'Ingredient Label Image',
  INGREDIENT_NAME: 'Ingredient Name',
  INGREDIENTS: 'Ingredients',
  IS_NOT_SAME: 'Is not the same',
  IS_REQUIRED: 'is required',
  INVOICE_DETAILS: 'Invoice Details',

  LANGUAGE: 'Language',
  LANGUAGES: 'Languages',
  LAST_ACCESS: 'Last Access',
  LAST_ACCESS_DATE: 'Last Access Date',
  LAST_ORDER_DATE: 'Last Order Date',
  LAST_NAME: 'Last Name',
  LEGAL_NAME: 'Legal Name',
  LOGIN_SUCCESS_MSG: 'Logged in Successfully',
  LOGOUT: 'Logout',

  MASTER_PASSWORD: 'Master Password',
  MASTER_PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Master Password updated successfully, logging out...',
  MEASURE_PER_UNITS: 'Measure per Unit',

  MEASURE_TYPE: 'Measure Type',
  MESSAGE_COMPOSE: 'Message Compose',
  MESSAGE_FILTERS: 'Message Filters',
  MESSAGE_FROM: 'Message From',
  MESSAGE_IS_REQUIRED: 'Message is Required',
  MESSAGE_TO: 'Message To',
  MESSAGES: 'Messages',
  MESSAGES_THREAD: 'Messages Thread',

  METHOD: 'Method',
  MOBILE: 'Mobile',
  MODIFYING_LANGUAGE: 'Modifying Language...',
  MODIFYING_PROFILE: 'Modifying Profile...',
  MODIFYING_SUPPLIER_DETAILS: 'Modifying Supplier Details...',

  NAME: 'Name',
  NEW: 'New',
  NEW_MESSAGE: 'New Message',
  NEW_PASSWORD: 'New Password',
  NO: 'No',
  NO_DATA_FOUND: 'No Data Found',
  NO_YES: 'Yes / No',
  NORMAL: 'Normal',
  NOT_APPLICABLE: 'Not Applicable',
  NUTRITION_IMAGE: 'Nutrition Label Image',

  OK: 'Ok',
  VIEW_REPLY: 'View / Reply',
  OLD_PASSWORD: 'Old Password',
  OTHER_DETAILS: 'Other Details',
  ORDERS: 'Orders',

  PARENT_ADDRESS: 'Parent Address',
  PARENT_CITY: 'Parent City',
  PARENT_COUNTRY: 'Parent Country',
  PARENT_EMAIL_ID: 'Parent Email ID',
  PARENT_POSTAL_CODE: 'Parent Zip/Postal Code',
  PARENT_POSTAL_CODE_ZIP: 'Parent Zip/Postal Code',
  PARENT_STATE: 'Parent State/Province',
  PARENT_WORK: 'Parent Work',
  PARENT_WORK_NUMBER: 'Parent Work Number',

  PASSWORD: 'Password',
  PASSWORD_IS_REQUIRED: 'Password is required',
  PASSWORD_MIN_LENGTH_ERROR: 'Minimum length of Password is 5 characters.',
  PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Password updated successfully, logging out...',
  PAYMENT: 'Payment',
  PHONE: 'Phone',

  PLEASE_ENTER_DESCRIPTION: 'Please enter Description',
  PLEASE_ENTER_SUBJECT: 'Please enter Subject',
  PLEASE_ENTER_VALID: 'Please enter valid ',
  PLEASE_ENTER_VALID_CREDINALS: 'Please enter valid credentials',
  PLEASE_FILL_ALL_FEILDS_BEFORE_SENDING_THE_MESSAGE:
    'Please complete all fields before sending the message',
  PLEASE_SELECT_NAME: 'Please select Name',
  PLEASE_TYPE_REACTIVATE: 'Please type REACTIVATE',
  PLEASE_UPLOAD: 'Please upload an image below 2 MB in size.',
  POSTAL_CODE: 'Zip/Postal Code',

  PREFERRED_SHIPPING_METHOD: 'Preferred Shipping Method',
  PRICE: 'Price',
  PRINT: 'Print',
  PRIORITY: 'Priority',

  PRODUCT: 'Product',
  PRODUCT_DETAILS: 'Product Details',
  PRODUCT_FILTER: 'Product Filter',
  PRODUCT_ID: 'Product ID',
  PRODUCT_IMAGE: 'Product Image',
  PRODUCT_NAME: 'Product Name',
  PRODUCT_QUANTITY: 'Product Quantity',
  PRODUCT_STATUS: 'Product Status',
  PRODUCT_TYPE: 'Product Type',
  PRODUCTS: 'Products',

  PROFILE: 'Profile',
  PROFILE_SETTINGS: 'Profile and Settings',
  PROVINCE: 'Province',

  QR_CODE: 'QR Code',
  QUANTITY_PER_UNIT: 'Quantity per unit',

  RATE_1: 'Rate 1',
  RATE_2: 'Rate 2',

  REACTIVATE: 'REACTIVATE',
  REACTIVATE_SUPPLIER: 'Reactivate Supplier',
  REACTIVATE_SUPPLIER_MESSAGE:
    'Are you sure you want to Reactivate this supplier?',
  REACTIVATING_SUPPLIER: 'Reactivating Supplier...',
  REACTIVE: 'Reactive',
  READ: 'Read',
  REC_SENT: 'Rec-sent',
  RECIPE_BUILDER: 'Recipe Builder',
  RECIPE_BUILDER_TYPE: 'Recipe Builder Type',
  RECIPE_BUILDER_REPORT: 'Recipe Builder Report',
  REMEMBER_ME: 'Remember me',
  REPLY: 'Reply',
  RETAIL_PRICE: 'Retail Price',
  ROWS_PER_PAGE: 'Rows per page',

  SAVE: 'Save',
  SAVE_CHANGES: 'Save Changes',
  SEARCH: 'Search',

  SELECT: 'Select ',
  SELECT_BILL_TO: 'Select Bill To',
  SELECT_CATEGORY: 'Select Category',
  SELECT_FROM: 'Select From',
  SELECT_LANGUAGE: 'Select Language',
  SELECT_TO: 'Select To',
  SELECT_RECIPE_BUILDER: 'Select Recipe Builder',

  SEND: 'Send',
  SEND_RECEIVE: 'Send/receive',
  SENDING_MESSAGES: 'Sending Messages...',
  SENDING_REPLIES: 'Sending Replies...',
  SENT: 'Sent',

  SET_AS_HIGH_PRIORITY: 'Set as High Priority',
  SET_MASTER_PASSWORD: 'Set Master Password',
  SET_PASSWORD: 'Set Password',
  SETUP_FEE: 'Setup Fee',

  SHIP_TO: 'Ship To',
  SHIPPING_CALCULATION: 'Shipping Calculation',
  SHIPPING_CHARGE: 'Shipping Charge',
  SHIPPING_CHARGES: 'Shipping Charges',
  SHIPPING_DETAILS: 'Shipping Details',
  SHIPPING_METHOD: 'Shipping Method',
  SHIPPING_RATE: 'Shipping Rate',

  SIGN_IN: 'Sign In',
  SIGN_IN_PORTAL: 'Order-EZ Admin Sign-In Portal',

  SKU_IMAGE: 'SKU Image',
  SKU_NUMBER: 'SKU Number',

  STATE: 'State/Province',
  STATUS: 'Status',

  STORE: 'Customer',
  STORE_ADDRESS: 'Customer Address',
  STORE_CITY: 'Customer City',
  STORE_CONTACT: 'Customer Contact',
  STORE_COUNTRY: 'Customer Countrys',
  STORE_ID: 'Customer ID',
  STORE_DETAILS: 'Customer Detailss',
  STORE_FILTER: 'Customer Filter',
  STORE_FILTERS: 'Customer Filters',
  STORE_LOGO: 'Customer Logo',
  STORE_NAME: 'Customer Name',
  STORE_POSTAL_CODE: 'Customer Zip/Postal Code',
  STORE_STATE: 'Customer State/Province',
  STORE_TAX1: 'Customer Tax Name (1)',
  STORE_TAX1_RATE: 'Customer Tax Name (1)',
  STORE_TAX2: 'Store Tax2',
  STORE_TAX2_RATE: 'Store Tax2 Rate',
  STORES: 'Customers',
  STORE_STATE_PROVINCE: 'Customer State/Province',

  SUB_CATEGORY: 'Subcategory',
  SUBJECT: 'Subject',
  SUBCATEGORY: 'Subcategory',
  SUBSCRIPTION_PACK: 'Subscription Pack',

  SUPPLIER_ADDRESS: 'Supplier Address',
  SUPPLIER_CITY: 'Supplier City',
  SUPPLIER_CONTACT: 'Supplier Contact',
  SUPPLIER_COUNTRY: 'Supplier Country',
  SUPPLIER_DETAILS: 'Supplier Details',
  SUPPLIER_EMAIL: 'Supplier Email',
  SUPPLIER_ID: 'Supplier ID',
  SUPPLIER_NAME: 'Supplier Name',
  SUPPLIER_FILTER: 'Supplier Filter',
  SUPPLIER_LOGO: 'Supplier Logo',
  SUPPLIER_POSTAL_CODE: 'Supplier Zip/Postal Code',
  SUPPLIER_PROVINCE: 'Supplier Province',
  SUPPLIER_STATE: 'Supplier State/Province',
  SUPPLIER_TAX1: 'Supplier Tax 1',
  SUPPLIER_TAX1_RATE: 'Supplier Tax1 Rate',
  SUPPLIER_TAX2: 'Supplier Tax 2',
  SUPPLIER_TAX2_RATE: 'Supplier Tax2 Rate',
  SUPPLIER_WORK: 'Supplier Work',
  SUPPLIERS: 'Suppliers',
  SUPPLIER_STATE_PROVINCE: 'Supplier State/Province',
  STATE_PROVINCE: 'State/Province',

  TAG: 'Tag',
  TAX_DESCRIPTION: 'Tax Description',
  TAX_NUMBER1: 'Tax Number 1',
  TAX_NUMBER2: 'Tax Number 2',
  TAX_RATE: 'Tax Rate',
  TAX1: 'Tax 1',
  TAX2: 'Tax 2',
  TAXES: 'Taxes',
  TERMS: 'Terms',
  TO: 'To',
  TO_ALL_SUPPLIERS: 'To all suppliers',
  TOTAL_ORDER_VALUE: 'Total Order Value',
  TOTAL_ORDERS: 'Total Orders',
  TOTAL_REQUIRED: 'Total Required',

  TYPE_DEACTIVATE_HERE: 'Type DEACTIVATE here',
  TYPE_REACTIVATE_HERE: 'Type REACTIVATE here',

  UNIT_OF_MEASURE: 'Units of Measure',
  UPDATE: 'Update',
  UPDATE_CATEGORY_DETAILS: 'Updating Category Details...',
  UPDATING_SUBCATEGORIES_DETAILS: 'Updating Subcategory Details...',
  UPLOAD: 'Upload',
  UPLOADING_LOGO: 'Uploading Logo...',
  UPLOADING_PROFILE_IMAGE: 'Uploading Profile Image...',

  URGENT: 'Urgent',
  USERNAME: 'Username',
  USER_NAME: 'User name',

  VALUES: 'Values',
  VERSION: 'Version',
  YES: 'Yes',
  WORK: 'Work',
  YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST:
    'You must complete all required fields or changes will be lost',
  BACK: 'Back',
  CONTINUE: 'Continue',
  NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS:
    'Note: You can enter up to 500 characters.',
  PLEASE_ENTER_VALID_PARENT_CITY: 'Please enter valid parent city',
  ENTER_VALID_ACCOUNTG_CODE: 'Please Enter Valid Accounting Code',
  PLEASE_ENTER_VALID_USERNAME: 'Please enter valid Username',
  PLEASE_ENTER_VALID_SUPPLIER_NAME: 'Please enter valid Supplier Name',
  PLEASE_ENTER_VALID_EMAIL: 'Please enter valid Email ID',
  PLEASE_ENTER_VALID_FIRST_NAME: 'Please enter valid First Name',
  PLEASE_ENTER_VALID_LAST_NAME: 'Please enter valid Last Name',

  PLEASE_ENTER_VALID_WORK_NUMBER: 'Please enter valid Work Number',
  PLEASE_ENTER_SUPPLIER_TAX1: 'Please enter valid supplier tax 1',
  PLEASE_ENTER_SUPPLIER_TAX2: 'Please enter valid supplier tax 2',
  PLEASE_ENTER_VALID_MOBILE: 'Please enter valid mobile',
  PLEASE_ENTER_COMPANY_NAME: 'Please enter valid company name',
  PLEASE_ENTER_VALID_SUPPLIER_POSTAL_CODE:
    'Please enter valid Supplier Zip/Postal Code',
  PLEASE_ENTER_VALID_SUBJECT: 'Please enter valid subject',
  ENTER_SUPPLIER_ADDRESS: 'Enter Supplier Address',
  ENTER_COMPANY_NAME: 'Enter Company Name',
  ENTER_COMPANY_ADDRESS: 'Enter Company Address',
  ENTER_CITY: 'Enter city',
  ENTER_SUPPLIER_WORK: 'Enter Supplier Work',
  ENTER_PARENT_EMAIL_ID: 'Enter parent email ID',
  ENTER_SUPPLIER_EMAIL_ID: 'Enter Supplier EmailID',
  ENTER_SUPPLIER_TAX_1: 'Enter Supplier Tax 1',
  ENTER_SUPPLIER_TAX_2: 'Enter Supplier Tax 2',
  ENTER_PARENT_WORK_NUMBER: 'Enter parent work number',
  ENTER_SUPPLIER_TAX1_RATE: 'Enter Supplier Tax Rate (1)',
  ENTER_SUPPLIER_TAX2_RATE: 'Enter Supplier Tax Rate (2)',
  ENTER_DESCRIPTION: 'Enter Description',
  PLEASE_ENTER_VALID_PARENT_POSTAL_CODE:
    'Please enter valid parent Zip/Postal Code ',
  ENTER_POSTAL_CODE: 'Enter Zip/Postal Code ',
  SELECT_STATE: 'Select State/Province',
  SELECT_COUNTRY: 'Select Country',
  SELECT_PARENT_COUNTRY: 'Select parent country',
  SELECT_PARENT_STATE: 'Select parent State/Province',
  SELECT_PAYMENT_METHOD: 'Select payment method',
  SELECT_TERMS: 'Select Terms',
  ENTER_CURRENT_PASSWORD: 'Enter current password',
  ENTER_NEW_PASSWORD: 'Enter new password',
  ENTER_CONFIRM_PASSWORD: 'Enter Confirm password',
  ENTER_SUBJECT: 'Enter subject',
  SELECT_SUPPLIER_STATE_PROVINCE: 'Select supplier State/Province',
  SELECT_BILL_TO_COUNTRY: 'Select bill to country',
  SELECT_STATE_PROVINCE: 'Select State/Province',
  SELECT_SETUP_FEE: 'Select setup fee',
  SELECT_SUBSCRIPTION_PACK: 'Select subscription pack',
  SELECT_SUPPLIER_TAX1: 'Select supplier tax 1',
  SELECT_SUPPLIER_TAX2: 'Select supplier tax 2',
  SELECT_CITY: 'Select city',
  SELECT_POSTAL_CODE: 'Select Zip/Postal Code',

  TAX_DESCRIPTION_IS_REQUIRED: 'Tax description is required',
  TAX_RATE_IS_REQUIRED: 'Tax rate is required',
  INVALID_IMG_DIMENTIONS:
    'Invalid image dimensions. Please use 1280x720 or 1920x1080',
  NEW_CONFIRM_PASSWORD_IS_NOT_SAME:
    'Passwords do not match. Please check and try again.',
  PRICE_MUST_BE_GREATER_THAN_ZERO: 'Price must be greater than zero',
  QUANTITY_MUST_BE_GREATER_THAN_ZERO: 'Quantity must be greater than zero',
  REQUESTED_DELIVERY_DATE_IS_REQUIRED: 'Requested delivery date is required',
  REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE:
    'FRequested delivery date must be in the future',
  THIS_PRODUCT_IS_ALREADY_ADDED: 'This product is already added',
  QUANTITY_MUST_GREATER_THAN_ZERO: 'Quantity must be greater than 0',
  LOGGED_IN_SUCCESSFULLY: 'Logged in successfully',
  NO_DATA_FOUND_SUB_FOR_CATEGORY: 'No data found for Sub Category',
  NO_PRODUCTS_SELECTED_ASSIGNMENT: 'No products selected for status update',
  SELECT_ALL_ROWS_ASSIGNMENT: 'Selected all rows products for status update',
  DUE_DATE_IS_REQUIRED: 'Due date is required',
  PRODUCTION_REPORT_IS_REQUIRED: 'Production report is required',
  INGREDIENT_NAME_REQUIRED: 'Ingredient name is required',
  INGREDIENTS_IS_REQUIRED: 'Ingredient is required',
  PRODUCT_NAME_CANNOT_SAME: 'Product name cannot be the same',
  INGREDIENTS_ALLREADY_ADDED: 'This ingredient is already added',
  SHIPPING_METHOD_IS_REQUIRED: 'Shipping method is required',
  TAX_REQUIRED: 'Tax is required',
  TAX_RATE_REQUIRED: 'Tax rate is required',
  NO_PRODUCTS_ASSIGNMENT: 'No products selected for assignment.',
  NO_PRODUCTS_SELECTED_UNASSIGNMENT: 'No products selected for unassignment.',
  FETCHING_INVOICE_DETAILS: 'Fetching Invoice Details...',
  FETCHING_PRODUCTION_REPORT: 'Fetching Production Report...',
  GETTING_REPORT: 'Getting Report',
  CANCELLING_PRODUCTION: 'Cancellling Production...',
  NEW_PRODUCT_ADDED: 'New Product added successfully',
  SELECT_PRODUCTION_REPORT: 'Select production report',
  CONFIRMATION: 'CONFIRMATION',
  ENTER_TAX_DESCRIPTION: 'Enter tax description',
  ENTER_TAX_RATE: 'Enter tax rate',
  PLEASE_ENTER_ADMIN_TAX1: 'Please enter admin tax 1',
  PLEASE_ENTER_ADMIN_TAX2: 'Please enter admin tax 2',
  ENTER_ADMIN_TAX_1: 'Enter admin tax 1',
  ENTER_ADMIN_TAX_2: 'Enter admin tax 2',
  ADMIN_TAX1: 'Admin Tax 1',
  ADMIN_TAX2: 'Admin Tax 2',

  IMAGE_UPLOAD_MESSAGE:
    'Accepted Image Formats: JPG, PNG, JPEG | Max File Size: 2MB | Preferred Resolution: 1280x720 pixels',

  READ_REPLY: 'Read / Reply',
  USA: 'USA',
  CANADA: 'Canada',

  // Canada State--
  ONTARIO: 'Ontario',
  QUEBEC: 'Quebec',
  NOVA_SCOTIA: 'Nova Scotia',
  NEW_BRUNSWICK: 'New Brunswick',
  MANITOBA: 'Manitoba',
  BRITISH_COLUMBIA: 'British Columbia',
  PRINCE_EDWARD_ISLAND: 'Prince Edward Island',
  SASKATCHEWAN: 'Saskatchewan',
  ALBERTA: 'Alberta',
  NEWFOUNDLAND_AND_LABRADOR: 'Newfoundland and Labrador',

  // USA State--
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'California',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  DISTRICT_OF_COLUMBIA: 'District of Columbia',
  FLORIDA: 'Florida',
  GEORGIA: 'Georgia',
  HAWAII: 'Hawaii',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiana',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'New Mexico',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'North Carolina',
  NORTH_DAKOTA: 'North Dakota',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'South Carolina',
  SOUTH_DAKOTA: 'South Dakota',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginia',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'West Virginia',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming',

  B2B: 'B2B',
  B2C: 'B2C (Coming Soon)',
  CHAINSTORE: 'Chain Store',
  SUPPLIER: 'Supplier',
  OTHER: 'Other',
  // Payment Methods
  CREDIT_CARD: 'Credit Card',
  Interac: 'Interac',
  Line: 'Line',
  Check: 'Check',
  Other: 'Other',
  TBA: 'TBA',
  SUPPLIER_DEACTIVATED_SUCCESS: 'Supplier deactivated successfully',
  SUPPLIER_DEACTIVATION_FAILED: 'Failed to deactivate Supplier',
  SUPPLIER_REACTIVATED_SUCCESS: 'Supplier reactivated successfully',
  SUPPLIER_REACTIVATION_FAILED: 'Failed to reactivate Supplier',
  SUPPLIER_ADDED_SUCCESS: 'Supplier added successfully',
  SUPPLIER_ADDITION_FAILED: 'Failed to add Supplier',
  SUPPLIER_UPDATED_SUCCESS: 'Supplier updated successfully',
  SUPPLIER_UPDATE_FAILED: 'Failed to update Supplier',

  PROFILE_UPDATED_SUCCESS: 'Profile updated successfully',
  PROFILE_UPDATE_FAILED: 'Failed to update Profile',
  POWERED_BY_ORDER_EZ: 'Powered by Order-EZ.com',
};
